import React, { useState, useEffect } from 'react';
import customAuthService from '../services/CustomAuth.service';

/**
 * Componente que exibe indicador quando a sessão está em modo de tarefa longa
 * Mostra um banner informando que a sessão será renovada automaticamente
 */
const LongTaskSessionIndicator = () => {
  const [isLongTaskMode, setIsLongTaskMode] = useState(false);
  const [taskName, setTaskName] = useState('');
  const [lastRenewal, setLastRenewal] = useState(null);

  useEffect(() => {
    // Verificar estado inicial
    const checkMode = () => {
      const mode = customAuthService.isLongTaskMode();
      setIsLongTaskMode(mode);
    };

    checkMode();

    // Listener para eventos específicos
    const unsubscribe = customAuthService.addEventListener((event) => {
      if (event.type === 'longTaskModeEnabled') {
        setIsLongTaskMode(true);
        setTaskName(event.taskName || 'Processamento');
      } else if (event.type === 'longTaskModeDisabled') {
        setIsLongTaskMode(false);
        setTaskName('');
      } else if (event.type === 'sessionRenewed' && event.reason === 'modo tarefa longa') {
        setLastRenewal(new Date().toLocaleTimeString());
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  if (!isLongTaskMode) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#4CAF50',
        color: 'white',
        padding: '12px 20px',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        fontSize: '14px',
        fontWeight: '500',
        gap: '12px',
      }}
    >
      <span
        className="material-symbols-outlined"
        style={{
          fontSize: '20px',
          animation: 'pulse 2s ease-in-out infinite',
        }}
      >
        autorenew
      </span>
      
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div>
          <strong>🔄 Modo Tarefa Longa Ativo:</strong> {taskName}
        </div>
        <div style={{ fontSize: '12px', opacity: 0.9, marginTop: '2px' }}>
          Sua sessão será renovada automaticamente a cada 2 horas
          {lastRenewal && ` • Última renovação: ${lastRenewal}`}
        </div>
      </div>

      <button
        onClick={() => {
          if (window.confirm('Deseja desativar o modo de tarefa longa? Sua sessão voltará a expirar em 2 horas sem atividade.')) {
            customAuthService.disableLongTaskMode();
          }
        }}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          color: 'white',
          padding: '6px 12px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '600',
          transition: 'background 0.2s',
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255,255,255,0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255,255,255,0.2)';
        }}
      >
        Desativar
      </button>

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
              transform: rotate(0deg);
            }
            50% {
              opacity: 0.7;
              transform: rotate(180deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default LongTaskSessionIndicator;
